import React from "react";
import { makeStyles } from "../../../lib/mui-imports";
import { PaletteFromHex } from "../../../helpers/palette";
import { Fonts } from "../../../constant/fonts";

export default function AppStyles(props) {
    const { color, font } = props.variables;

    let AppStyles = {
        AppStyles: {
            height: "100%",
            minHeight: "100vh",
            fontFamily: "'Roboto', sans-serif",

            "& button, .button": {
                textDecoration: "none",
            },

            "& .w1200px": {
                width: "100vw !important",
                maxWidth: "1200px !important",

                "@media (max-width: 1200px)": {
                    width: "100% !important",
                    maxWidth: "100% !important",
                },
            },

            "& .inner-block": {
                maxWidth: "1200px !important",
                margin: "auto",
            },

            "@media (max-width: 600px)": {
                "& .media-desktop": {
                    display: "none",
                },
            },
            "@media (min-width: 600px)": {
                "& .media-mobile": {
                    display: "none",
                },
            },

            // Link
            "& .link": {
                "&:hover": {
                    textDecoration: "none",
                },
            },

            // Desktop
            "& .desktop-240px-height": {
                height: "240px",
            },

            // Texts
            "& h1, .text-h1": {
                fontSize: "32px",
                fontWeight: "bold",
            },

            "& h2, .text-h2": {
                fontSize: "30px",
                fontWeight: "bold",
            },

            "& .text-left": { textAlign: "left" },
            "& .text-center": { textAlign: "center" },
            "& .text-right": { textAlign: "right" },

            // Feature
            "& .override-feature-50 .feature": {
                width: "calc(50% - 16px)",
            },
            "& .override-feature-100 .feature": {
                width: "100%",
            },

            // Padding
            "& .padding-x-16": {
                paddingLeft: "16px",
                paddingRight: "16px",
            },

            // Grid
            "& .grid-column": {
                display: "grid",
                gridAutoFlow: "column",
            },
            "& .grid-center": {
                display: "grid",
                justifyContent: "center",
            },
            "& .grid-left": {
                display: "grid",
                justifyContent: "flex-start",
            },
            "& .grid-right": {
                display: "grid",
                justifyContent: "flex-end",
            },
            "& .grid-top": {
                display: "grid",
                alignItems: "flex-start",
            },
            "& .grid-middle": {
                display: "grid",
                alignItems: "center",
            },
            "& .grid-bottom": {
                display: "grid",
                alignItems: "flex-end",
            },
            "& .grid-gap-16": {
                display: "grid",
                gridGap: "16px",
            },
            "& .grid-gap-32": {
                display: "grid",
                gridGap: "32px",
            },

            // Flex
            "& .flex-left": {
                display: "flex",
                justifyContent: "flex-start",

                "&.flex-column": {
                    height: "max-content",
                    justifyContent: "center",
                    alignItems: "flex-start",
                },
            },
            "& .flex-center": {
                display: "flex",
                justifyContent: "center",

                "&.flex-column": {
                    height: "max-content",
                    justifyContent: "center",
                    alignItems: "center",
                },
            },
            "& .flex-right": {
                display: "flex",
                justifyContent: "flex-end",

                "&.flex-column": {
                    height: "max-content",
                    justifyContent: "center",
                    alignItems: "flex-end",
                },
            },
            "& .flex-middle": {
                display: "flex",
                alignItems: "center",

                "&.flex-column": {
                    height: "max-content",
                    justifyContent: "center",
                    alignItems: "center",
                },
            },
            "& .flex-column": {
                display: "flex",
                flexDirection: "column",
            },
            "& .flex-wrap": {
                display: "flex",
                flexWrap: "wrap",
            },
            "& .flex-gap-16": {
                display: "grid",
                gridAutoFlow: "column",
                gridGap: "16px",
            },
            "& .flex-gap-8": {
                display: "flex",
                gap: "8px",
            },
        },
    };

    if (font && color) {
        const { initial, initialText, initialTextInvert, initialTextIsLight, lighter } = PaletteFromHex(
            color.userPrimary ?? color.primary
        );

        AppStyles = {
            AppStyles: {
                ...AppStyles.AppStyles,

                display: "grid",
                height: "100%",
                minHeight: "100vh",
                fontFamily: Fonts[font] ? `'${font}', ${Fonts[font].familyBase}` : null,

                "& .bg-hover": {
                    transition: "all 250ms ease",
                },

                "& > *": {
                    padding: "64px 0",
                },

                // ODD ------------------------------------------------------ //
                // WhiteBG
                "& > :nth-child(odd):not(.ignore-global)": {
                    backgroundColor: "#ffffff",
                    color: "#000000",

                    "& .invert-bg": {
                        backgroundColor: initial,
                        color: initialText,
                    },

                    "& .feature.offer-variant-2": {
                        color: "#000000",
                    },

                    "& .feature.offer-variant-3": {
                        color: "#000000",
                    },

                    "& .step.step-variant-2": {
                        color: "#000000",
                    },

                    "& .step.step-variant-3": {
                        color: "#000000",
                    },

                    "& .filter-brightness:not(.ignore-global)": {
                        filter: "brightness(0)",
                        filter: `brightness(0) ${initialTextIsLight ? "invert(1)" : ""}`,
                    },

                    "& .bg-visible": {
                        backgroundColor: initial,
                        color: initialText,

                        "&.bg-visible-reverse": {
                            backgroundColor: "#ffffff",
                        },
                    },

                    "& .bg-hover:hover": {
                        backgroundColor: lighter,
                    },
                },

                // EVEN ----------------------------------------------------- //
                // PrimaryBG
                "& > :nth-child(even):not(.ignore-global)": {
                    backgroundColor: initial,
                    color: initialText,

                    "& .invert-bg": {
                        backgroundColor: "#ffffff",
                        color: "#000000",
                    },

                    "& .feature.offer-variant-1": {
                        backgroundColor: "#ffffff",
                        color: "#000000",
                    },

                    "& .feature.offer-variant-2": {
                        borderColor: "#ffffff",
                        backgroundColor: initial,
                    },

                    "& .feature.offer-variant-3": {
                        borderColor: "#ffffff",
                        backgroundColor: initial,
                    },

                    "& .step.step-variant-1": {
                        backgroundColor: "#ffffff",
                        color: "#000000",
                    },

                    "& .step.step-variant-2": {
                        borderColor: "#ffffff",
                        backgroundColor: initial,
                    },

                    "& .step.step-variant-3": {
                        borderColor: "#ffffff",
                        backgroundColor: initial,
                    },

                    "& .filter-brightness:not(.ignore-global)": {
                        filter: `brightness(0) ${initialTextIsLight ? "invert(1)" : ""}`,
                    },

                    "& .bg-visible": {
                        backgroundColor: "#ffffff",
                        color: "#000000",

                        "&.bg-visible-reverse": {
                            backgroundColor: initial,
                        },
                    },

                    "& .bg-hover:hover": {
                        backgroundColor: lighter,
                    },
                },
            },
        };
    }

    return <div className={makeStyles(AppStyles, { name: "AppStyles" })().AppStyles}>{props.children}</div>;
}
